module.exports = __webpack_public_path__ + "static/media/uni-cc-01.635473b6.png";